import React from 'react';
import {spaData} from '../components/helpers/spaSections'

const SpaPage = () => {
    return (
        <div className="spa-page-container"> {/* Контейнер страницы для SPA */}
            <header className="page-header"> {/* Переиспользуем класс заголовка страницы */}
                <h1>{spaData.title}</h1> {/* Главный заголовок страницы из данных */}
            </header>

            {/* Так как нет секций, рендерим список карточек напрямую */}
            <div className="sections-wrapper"> {/* Можно переиспользовать обертку для отступов */}
                <div className="treatment-cards-list"> {/* Переиспользуем класс контейнера списка карточек */}
                    {/* Проходимся напрямую по массиву из submenu */}
                    {spaData.submenu.map((item, index) => (
                        // Переиспользуем класс карточки
                        <div className="treatment-card" key={index}> {/* Карточка SPA Процедуры */}
                            {/* Переиспользуем класс контентной части */}
                            <div className="treatment-card-content"> {/* Контентная часть карточки */}
                                {/* Баннер с названием процедуры - ПЕРЕИСПОЛЬЗУЕМ КЛАСС */}
                                {/* Баннер необязателен, если не нужен */}
                                {/* <div className="treatment-card-banner">{item.title}</div> */}

                                {/* Используем заголовок из данных */}
                                <h3 className="treatment-item-title">{item.title}</h3> {/* Название Процедуры */}
                                {/* Используем Примерное описание */}
                                <p className="treatment-item-description">{item.description}</p> {/* Описание */}
                                {/* Кнопка "О ПРОГРАММЕ" пока нет */}
                            </div>
                            {/* Переиспользуем класс контейнера картинки */}
                            <div className="treatment-card-image-container"> {/* Контейнер для картинки */}
                                {/* Используем Placeholder картинку (или реальную, если добавишь) */}
                                {item.imageUrl && <img src={item.imageUrl} alt={item.title} className="treatment-card-image"/>} {/* Картинка */}
                            </div>
                        </div>
                        ))}
                </div> {/* Конец .treatment-cards-list */}
            </div> {/* Конец .sections-wrapper */}


        </div> // Конец .spa-page-container
    );
};

export default SpaPage;